<template>
	
	
	<el-dialog title="信息" :visible.sync="artcleShow" :append-to-body="true" width="50%">
		
		<div  class="videoBox">
								<div class="introduceBox">
									<div class="title">
										余米综合服务平台
									</div>
									<!-- <div class="blueBar"></div> -->
									<div class="contact">
										余米综合服务平台<br>
										余米科技服务有限公司是一家具备财税专家、互联网、软件精英等专业团队的高新技术企业，拥有多项软件开发著作和丰富业务经验。公司通过自主研发集技术红利、管理红利、政策红利等价值于一身的数字化经济平台，实现线上线下双线服务模式，致力于以创新模式为企业提供“互联网+服务”，帮助企业降低成本、减少经营风险，为协助企业构建良性运营生态系统提供优质全面的服务。
									</div>
								</div>
								<div class="grayBar"></div>
								<div class="videoPlayBox">
									<video src="http://file.yjyumi.com/js.mp4" style = "width: 100%;height: 100%;" controls="controls">
									您的浏览器不支持 video 标签。
									</video>
								</div>
		
							</div>
		
		
		
		
	</el-dialog>
	
	
	
	
</template>

<script>
	export default{
		
		data(){
			
			return {
				
				artcleShow:false
				
			}
			
		}
		
		
	}
</script>

<style>
	.videoBox {
	
		height: auto;
		width: 100%;
		background: #FFFFFF;
		display: flex;
		background-image: url(http://www.yjyumi.com/img/微信图片_20200310151447.png);
		background-repeat: no-repeat;
		background-position: 8.625rem -6.75rem;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
	
	}
	
	.introduceBox {
		margin-top: 5.6875rem;
		width: 100%;
		height: auto;
	}
	
	.introduceBox .title {
		font-family: SourceHanSansCN-Medium;
		font-size: 3vw;
		font-weight: normal;
		font-stretch: normal;
		line-height: 1.5rem;
		letter-spacing: 0px;
		color: #000000;
	
	}
	
	.videoPlayBox {
		position: relative;
		top: -3.5rem;
		width: 100%;
		height: auto;
		background-color: #535353;
		z-index: 1;
	}
	
	.blueBar {
		margin-top: 2rem;
		margin-bottom: 1rem;
		width: 10vw;
		height: 0.3125rem;
		background-color: #2747b2;
	}
	
	.grayBar {
		position: relative;
		width: 100%;
		top: 37.0625rem;
		height: 11.375rem;
		background-color: #f4f4f4;
		z-index: 0;
	}
	
	.contact {
	
		font-family: SourceHanSansCN-Regular;
		font-size: 1vw;
		font-weight: normal;
		font-stretch: normal;
		line-height: 1.875rem;
		letter-spacing: 0px;
		color: #666666;
	}
</style>
